import PrivateRoute from './components/PrivateRoute';

const components = { PrivateRoute };

export { components };